import { useInboxStore } from '../../stores/inbox-store';
import { CustomerLinker, type LinkerSelection } from './CustomerLinker';

interface Props {
  open: boolean;
  conversationId: string;
  fromEmail?: string;
  fromName?: string;
  onClose: () => void;
}

export function CustomerLinkerModal({ open, conversationId, fromEmail, fromName, onClose }: Props) {
  const linkCustomer = useInboxStore((s) => s.linkCustomerToConversation);

  if (!open) return null;

  const initialQuery = fromName || (fromEmail ? fromEmail.split('@')[1] || fromEmail : '');

  async function handleSelect(selection: LinkerSelection) {
    await linkCustomer({
      conversationId,
      customerId: selection.customerId,
      customerType: selection.customerType,
      customerName: selection.customerName,
      contactId: selection.contactId,
      contactName: selection.contactName,
      rememberDomain: selection.rememberDomain,
    });
    onClose();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-[60]" onClick={onClose} />
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-xl pointer-events-auto">
          <div className="px-5 py-4 border-b border-slate-200">
            <h3 className="text-base font-semibold text-slate-900">Klant koppelen</h3>
            {fromEmail && (
              <p className="text-xs text-slate-500 mt-0.5">
                Email afkomstig van <span className="font-mono">{fromEmail}</span>
              </p>
            )}
          </div>
          <div className="px-5 py-4">
            <CustomerLinker
              initialQuery={initialQuery}
              fromEmail={fromEmail}
              onSelect={handleSelect}
              onCancel={onClose}
            />
          </div>
        </div>
      </div>
    </>
  );
}
